<template>
  <div>
    <div class="events-ct">
      <!-- Event selector section -->
      <event-selector-inapp v-if="isInApp" :model="model" />
      <event-selector-extended v-else-if="isExtended" :model="model" />
      <event-selector v-else :model="model" />

      <!-- Delay section -->
      <delay v-if="displayDelaysBlock" :model="model" />

      <!-- Qualification trigger -->
      <form-section-checkbox
        v-model="model.qualification"
        :title="$t('CampaignForm_Events_QualificationTrigger_Title')"
        :description="$t('CampaignForm_Events_QualificationTrigger_Desc')"
        v-if="displayQualification"
      >
        <qualification-trigger :model="model" />
      </form-section-checkbox>

      <!-- Limits section -->
      <message-limits :model="model" v-if="!model.qualification" />
    </div>

    <div class="footer">
      <div class="footer-ct">
        <el-button type="primary" @click="nextStep" data-qa="next-step-btn">
          {{ $t('CampaignForm_Events_NextButton_Title') }}
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Delay from '@/modules/campaign-manage/components/events/Delay.vue'
import EventSelector from '@/modules/campaign-manage/components/events/EventSelector'
import EventSelectorInapp from '@/modules/campaign-manage/components/events/EventSelectorInapp'
import EventSelectorExtended from '@/modules/campaign-manage/components/events/EventSelectorExtended'
import MessageLimits from '@/modules/campaign-manage/components/events/MessageLimits'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'
import { campaignTriggerTypes } from '@/modules/campaign-manage/enum/CampaignTriggerTypesEnum'
import { EventBus } from '@/core/EventBus'
import QualificationTrigger from '../components/events/QualificationTrigger'
import FormSectionCheckbox from '@/common/components/form/FormSectionCheckbox'
import { $hasFeature } from '@/core/utils/VueAcl'

export default {
  name: 'StepEvents',

  components: {
    FormSectionCheckbox,
    QualificationTrigger,
    Delay,
    MessageLimits,
    EventSelector,
    EventSelectorInapp,
    EventSelectorExtended
  },

  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      campaignTypeEnum
    }
  },

  computed: {
    isInApp() {
      return this.model.type === campaignTypeEnum.TYPE_INAPP
    },

    isExtended() {
      return this.model.event === 'system' || this.isConsentTriggerEnabled
    },

    isConsentTriggerEnabled() {
      return (
        $hasFeature('subscriptionPreferences') &&
        $hasFeature('campaignTriggerByConsentPrefEvents')
      )
    },

    displayDelaysBlock() {
      return (
        this.model.trigger === campaignTriggerTypes.TRIGGER_EVENT &&
        this.model.type !== campaignTypeEnum.TYPE_INAPP
      )
    },

    displayQualification() {
      return (
        this.displayDelaysBlock &&
        (this.model.qualification || $hasFeature('qualification'))
      )
    }
  },

  methods: {
    nextStep() {
      EventBus.$emit('campaign-create-next-step')
    }
  }
}
</script>

<style scoped>
.events-ct {
  padding-bottom: 60px;
}
.footer {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 60px;
  background: #ffffff;
  z-index: 1;
  border-top: 1px solid #e5e5e5;
}
.footer-ct {
  margin-right: 20px;
  margin-bottom: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/pages/StepEvents.vue